import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { Router } from '@angular/router';

import { PractitionerModel, PractitionerStoreModel } from './practitioner.model';
import { State } from '../../reducers/index';
import { SHOW_HEADER, OVERLAY_START } from '../../actions/header.action';
import { DATA_REQUEST, Data } from '../../actions/data.action';
import { INFO_UPDATE } from '../../actions/info.action';
import { Booking } from '../../actions/booking.action';

@Component({
  selector: 'consentz-practicioner',
  templateUrl: './practitioner.template.html',
  styleUrls: ['./practitioner.styles.scss']
})
export class PractitionerComponent implements OnInit, OnDestroy {
  public model: PractitionerModel = new PractitionerModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    JSON.parse(localStorage.getItem('treatmentPractitioners')),
    +localStorage.getItem('treatmentId'),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  public storeData: PractitionerStoreModel = new PractitionerStoreModel();

  constructor(
    private router: Router,
    private store: Store<State>
  ) {
    // hide header, allow ovelay, get pratitioners request
    this.store.dispatch({ type: SHOW_HEADER });
    this.store.dispatch({ type: OVERLAY_START });
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/${localStorage.getItem('treatmentId')}/practitioners`
      }
    });
    // subscribtion on widget options, server data, local selections
    this.storeData.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
    this.storeData.model$ = store.select<any>('data');
    this.storeData.info$ = store.select<any>('info');
  }
  // detect window size
  public sizeOfScreen(): number {
    return window.innerHeight;
  }
  // add to store practitioner
  public selectPractitioner(event: any, practitioner: any, index: number): void {
    event.stopPropagation();
    if (this.model.indexOfChosenPractitioner === index) {
      this.model.indexOfChosenPractitioner = null;
      localStorage.removeItem('practitionerId');
      this.store.dispatch({
        type: INFO_UPDATE,
        payload: {
          practitioner: null
        }
      });
    } else {
      this.model.indexOfChosenPractitioner = index;
      localStorage.setItem('practitionerId', practitioner.id);
      this.store.dispatch({
        type: DATA_REQUEST,
        payload: {
          requestUrl: `/online-booking/${localStorage.getItem('practitionerId')}/week`
        }
      });
      this.store.dispatch({
        type: INFO_UPDATE,
        payload: {
          practitioner: practitioner
        }
      });
    }
  }
  // show full practitioner
  public showMore(index: number, $event, practitioner): void {
    this.model.practitioners[index] = !this.model.practitioners[index];
    if (this.model.practitioners[index]) {
      this.selectPractitioner($event, practitioner, index);
    }
    this.setDynamicColor();
  }

  public ngOnInit(): void {
    // add permission for each practitioner -> show/hide full version
    this.storeData.subscribtion.data$ = this.storeData.model$.subscribe((data: Data) => {
      if (this.model.practitioners.length !== data['practitioners'].length) {
        this.model.practitioners = [];
        data['practitioners'].forEach((element: any, index: number) => {
          this.model.practitioners[index] = false;
        });
      }
    });
    this.setDynamicColor();
  }

  // unsubscribe from store
  public ngOnDestroy(): void {
    this.storeData.subscribtion.booking$.unsubscribe();
  }
  // set dynamic color for interface
  private setDynamicColor(): void {
    let style: any = null;
    if (document.querySelector('#css-dynamic-class')) {
      style = document.querySelector('#css-dynamic-class');
    } else {
      style = document.createElement('style');
      style.type = 'text/css';
      style.id = 'css-dynamic-class';
    }
    style.innerHTML = `.css-dynamic-class { background-color: ${this.model.currentBookingOptions.secondaryInterfaceColour}!important; }`;
    document.getElementsByTagName('head')[0].appendChild(style);

    const element: any = document.querySelector('.ui-scrollpanel-bar-y');
    element.classList.add('css-dynamic-class');
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/practitioner/practitioner.component.ts